import styled, { css } from 'styled-components'
import { ZIndex } from '../../constants'
import { media } from '../../theme/breakpoints'

type Background = 'default' | 'secondary'
type Divider = 'shadow' | 'border'

const backgroundStyles = {
    default: css``,
    secondary: css`
        background-color: ${(p) => p.theme.colors.tertiary.default};
    `,
}

const dividerStyles = {
    shadow: css`
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
        z-index: ${ZIndex.Controls};
    `,
    border: css`
        border-bottom: 2px solid;
        ${(p) =>
            `border-image-source: linear-gradient(90deg, ${p.theme.colors.tertiary.tertiary50} 0%, ${p.theme.colors.tertiary.tertiary100} 50%, ${p.theme.colors.tertiary.default} 100%);`}
        border-image-slice: 1;
    `,
}

interface Props {
    $background: Background
    $divider: Divider
}

export const ControlsContainer = styled.div<Props>`
    padding: 16px 32px;

    ${(props) => backgroundStyles[props.$background]}
    ${(props) => dividerStyles[props.$divider]}

    ${media.mobile} {
        padding: 16px 16px;
    }
`
